export const contactsData = {
    email: 'driss.eladama@umsba.ac.ma',
    phone: '+212682036263',
    address: 'My abdellah, Fes, Morocco - 30000 ',

    sheetAPI: 'https://sheetdb.io/api/v1/868n6q0zd7ifw'
}